
<app-header-title>
  <span title>{{'AttendingLeaving.Attending_Leaving'|translate}}</span>
</app-header-title>
<div style="padding: 1rem 2rem;">

<app-general-calc-salary-inputs 
  #salaryInputs
  [currentLang]="currentLang"
  (formDataChanged)="onFormDataChanged($event)">
</app-general-calc-salary-inputs>

<div style="padding: 1rem 3rem; margin-bottom: 1rem;">
  <dx-button 
    text="{{'search' | translate}}"
    [width]="200"
    (onClick)="applyFilter()">
  </dx-button>
  
  <dx-button 
    style="margin-right: 1rem;"
    text="{{'reset' | translate}}"
    type="normal"
    [width]="200"
    stylingMode="outlined"
    (onClick)="resetFilter()">
  </dx-button>
</div>
 <dx-data-grid 
  #grid 
  class="dx-card wide-card" 
  #dataGridVar 
  [dataSource]="customDataSource" 
  keyExpr="id"
  width="100%"
  [showBorders]="true" 
  [focusedRowEnabled]="true" 
  [columnAutoWidth]="true"
  [rtlEnabled]="currentLang=='ar'"
  (onRowUpdating)="updateRow($event)" 
  (onInitNewRow)="onInitNewRow($event)" 
  (onEditCanceling)="onEditCanceling()"
  (onEditorPreparing)="onEditorPreparing($event)" 
  (onEditingStart)="onEditingStart($event)">

  <!-- <dxo-editing mode="popup" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true"></dxo-editing> -->
   <dxo-export [enabled]="true" [allowExportSelectedData]="true" fileName="attending"></dxo-export>
 <dxi-column dataField="employeeId" caption="{{'tableinfo.employee'|translate}}" [visible]="false">
  <dxo-lookup [dataSource]="employeeDropDown" valueExpr="id" [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
</dxi-column>

 <dxi-column dataField="employeeName" caption="اسم الموظف" [width]="150"></dxi-column>

 <dxi-column dataField="dateOfDay" caption="التاريخ" [width]="150"></dxi-column>

  
  <dxi-column dataField="timeAttending" caption="وقت الحضور" [width]="150"></dxi-column>

 
  <dxi-column dataField="timeLeave" caption="وقت الانصراف" [width]="150"></dxi-column>

  <dxi-column dataField="durationName" caption="فترة العمل" [width]="180"></dxi-column>

</dx-data-grid>